(function() {
  'use strict';

  const modal = document.getElementById('quick-buy-modal');
  const modalContent = document.getElementById('quick-buy-product-content');
  const closeButton = modal ? modal.querySelector('[data-action="close-quick-buy-modal"]') : null;

  if (!modal || !modalContent) {
    // console.error('Quick buy modal elements not found. Make sure the modal HTML is included in the page.');
  }
  let currentProductData = null;
  let currentProductVariants = null;
  let currentFlickityInstance = null;
  let currentProductDiscountedPrice = null;

  const colorLabel = ['color', 'colour', 'couleur', 'colore', 'farbe', '색', '色', '색상', 'färg', 'farve', '颜色', '顏色'];
  const sizeLabel = ['size', 'taille', 'größe', 'tamanho', 'tamaño', 'koko', 'サイズ', '크기', '尺码', '尺碼', '尺寸'];

  const _config = window.quickBuyConfig || {};
  const _fileUrlBase = _config.fileUrlBase || '';
  const _strings = _config.strings || {};

  var colorSwatchConfig = (_config.rawSwatchConfig || '')
    .split('\n')
    .map(line => line.trim())
    .filter(line => line !== '');

  // Code by 643 - add selectedVariantId at function function openModal
  function openModal(productHandle, discountedPriceOverrides, selectedVariantId) {
  // End of 643
    if (!productHandle) {
      // console.error('No product handle provided');
      return;
    }

    if (!modal || !modalContent) {
      // console.error('Modal elements not found. Cannot open modal.');
      return;
    }

    currentProductDiscountedPrice = discountedPriceOverrides || null;
    modalContent.innerHTML = '<div class="quick-buy-loading"><p>' + escapeHtml(_strings.loading) + '</p></div>';
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    fetch(window.routes.rootUrlWithoutSlash + '/products/' + productHandle + '.js')
    .then(response => response.json())
    .then(product => {
      currentProductData = product;
      currentProductVariants = product.variants;
      // Code by 643 - add selectedVariantId
      renderProductModal(product, selectedVariantId);
      // End of 643
      initializeModal(product);
    })
    .catch(error => {
      // console.error('Error loading product:', error);
      modalContent.innerHTML = '<div class="quick-buy-error"><p>' + escapeHtml(_strings.loadError) + '</p></div>';
    });
  }

  function closeModal() {
    if (!modal || !modalContent) return;

    modal.setAttribute('aria-hidden', 'true');
    modal.classList.remove('is-open');
    document.body.style.overflow = '';

    if (currentFlickityInstance) {
      currentFlickityInstance.destroy();
      currentFlickityInstance = null;
    }

    setTimeout(() => {
      if (modalContent) {
        modalContent.innerHTML = '';
      }
      currentProductData = null;
      currentProductVariants = null;
    }, 300);
  }

  // Render content
  // Code by 643 - add initialVariantId at function renderProductModal
  function renderProductModal(product, initialVariantId) {
    // 643 - comment old
    // const selectedVariant = product.variants.find(v => v.available) || product.variants[0];
    const requestedVariantId = initialVariantId ? parseInt(initialVariantId, 10) : null;
    const requestedVariant = requestedVariantId ? product.variants.find(v => v.id === requestedVariantId) : null;
    const selectedVariant = requestedVariant || product.variants.find(v => v.available) || product.variants[0];
    // End of 643
    const selectedVariantId = selectedVariant ? selectedVariant.id : null;

    let productMedia = [];
    if (product.media && product.media.length > 0) {
      productMedia = product.media.filter(m => m.media_type === 'image');
    } else if (product.images && product.images.length > 0) {
      productMedia = product.images.map(img => ({
        src: img,
        alt: product.title,
        id: img
      }));
    }

    const selectedColor = getSelectedColor(product, selectedVariant);

    // Filter media by selected color, match by alt text or show all if no match
    let filteredMedia = productMedia.filter(m => {
      const alt = (m.alt || '').toLowerCase().trim();
      const colorLower = selectedColor.toLowerCase().trim();
      const titleLower = product.title.toLowerCase().trim();

      return alt === colorLower || alt === titleLower || !alt || alt === '';
    });

    if (filteredMedia.length === 0) {
      filteredMedia = productMedia;
    }

    let galleryHTML = '';
    let thumbnailsHTML = '';

    filteredMedia.forEach((media, index) => {
      const isSelected = index === 0;
      let imageUrl = media.src || media;

      if (typeof imageUrl === 'string') {
        imageUrl = imageUrl.replace(/_\d+x\d+/g, '');
        imageUrl = imageUrl.replace(/\?.*$/, '');
      }

      const imageUrl400 = imageUrl + (imageUrl.includes('?') ? '&' : '?') + 'width=400';
      const imageUrl800 = imageUrl + (imageUrl.includes('?') ? '&' : '?') + 'width=800';

      galleryHTML += `
        <div class="quick-buy-gallery-slide" data-media-id="${media.id || index}">
          <img src="${imageUrl800}" alt="${escapeHtml(media.alt || product.title)}" loading="${index === 0 ? 'eager' : 'lazy'}">
        </div>
      `;

      if (filteredMedia.length > 1) {
        thumbnailsHTML += `
          <button type="button" class="quick-buy-gallery-thumb ${isSelected ? 'is-selected' : ''}" data-index="${index}">
            <img src="${imageUrl400}" alt="${escapeHtml(media.alt || product.title)}">
          </button>
        `;
      }
    });

    // variant options part
    let variantOptionsHTML = '';
    if (product.options && product.options.length > 0) {
      product.options.forEach((option, optionIndex) => {
        const optionName = option.name;
        const optionValues = option.values;
        const downcaseOption = optionName.toLowerCase();
        const isColor = colorLabel.includes(downcaseOption);
        const isSize = sizeLabel.includes(downcaseOption);

        let selectedValue = '';
        if (selectedVariant && isColor) {
          const optionKey = 'option' + (optionIndex + 1);
          selectedValue = selectedVariant[optionKey] || '';
          if (selectedValue) {
            selectedValue = selectedValue.split('(')[0].trim();
          }
        }

        let labelText = optionName + ':';
        if (isColor && selectedValue) {
          labelText = optionName + ': ' + selectedValue;
        }

        variantOptionsHTML += `
          <div class="quick-buy-option" data-option-position="${optionIndex + 1}">
            <label class="quick-buy-option-label" data-option-type="${isColor ? 'color' : (isSize ? 'size' : 'other')}">${escapeHtml(labelText)}</label>
            <div class="quick-buy-option-values">
        `;

        optionValues.forEach((value, valueIndex) => {
          const isSelected = selectedVariant && getVariantOptionValue(selectedVariant, optionIndex + 1) === value;

          // to check availability with currently selected variant
          const testOptions = {};
          if (selectedVariant) {
            for (let i = 1; i <= 3; i++) {
              const optionKey = 'option' + i;
              if (selectedVariant[optionKey]) {
                testOptions[i] = selectedVariant[optionKey];
              }
            }
          }
          testOptions[optionIndex + 1] = value;

          const isAvailable = isVariantValueAvailable(product.variants, optionIndex + 1, value, selectedVariant, testOptions);

          if (isColor) {
            const colorName = value.toLowerCase().replace(/\s*\(.*?\)/g, '').trim();
            const colorSwatchStyle = getColorSwatchStyle(value);
            variantOptionsHTML += `
              <div class="quick-buy-color-swatch-wrapper">
                <input type="radio"
                  id="quick-buy-option-${optionIndex}-${valueIndex}"
                  name="quick-buy-option-${optionIndex}"
                  value="${escapeHtml(value)}"
                  ${isSelected ? 'checked' : ''}
                  data-option-position="${optionIndex + 1}"
                  data-is-available="${isAvailable}"
                  class="quick-buy-option-input">
                <label for="quick-buy-option-${optionIndex}-${valueIndex}"
                  class="quick-buy-color-swatch ${!isAvailable ? 'is-unavailable' : ''} ${isSelected ? 'is-selected' : ''} ${colorName === 'white' ? 'quick-buy-color-swatch--white' : ''}"
                  style="${colorSwatchStyle}">
                  <span class="tooltip">${escapeHtml(value.split('(')[0].trim())}</span>
                </label>
              </div>
            `;
          } else {
            variantOptionsHTML += `
              <button type="button"
                      class="quick-buy-option-button ${!isAvailable ? 'is-unavailable' : ''} ${isSelected ? 'is-selected' : ''}"
                      data-value="${escapeHtml(value)}"
                      data-option-position="${optionIndex + 1}">
                ${escapeHtml(value)}
              </button>
            `;
          }
        });

        variantOptionsHTML += `
            </div>
          </div>
        `;
      });
    }

    // Price part
    const price = selectedVariant ? selectedVariant.price : product.price;
    const compareAtPrice = selectedVariant && selectedVariant.compare_at_price > price ? selectedVariant.compare_at_price : null;
    const currencyFormat = window.theme && window.theme.currencyCodeEnabled ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat;

    let priceHTML = '';
    if (compareAtPrice) {
      priceHTML = `
        <span class="quick-buy-price-current Price--highlight">${formatMoney(price, currencyFormat)}</span>
        <span class="quick-buy-price-compare">${formatMoney(compareAtPrice, currencyFormat)}</span>
      `;
    } else if (currentProductDiscountedPrice && (currentProductDiscountedPrice.discountedPriceCents != null && currentProductDiscountedPrice.discountedPriceCents !== '') && (currentProductDiscountedPrice.originalPriceCents != null && currentProductDiscountedPrice.originalPriceCents !== '')) {
      const discountedCents = parsePriceCents(currentProductDiscountedPrice.discountedPriceCents);
      const originalCents = parsePriceCents(currentProductDiscountedPrice.originalPriceCents);
      priceHTML = `
        <span class="quick-buy-custom-discounted-price">${formatMoney(discountedCents, currencyFormat)}</span>
        <span class="quick-buy-price-compare">${formatMoney(originalCents, currencyFormat)}</span>
      `;
    } else {
      priceHTML = `<span class="quick-buy-price-current">${formatMoney(price, currencyFormat)}</span>`;
    }

    const html = `
      <div class="quick-buy-gallery">
        <div class="quick-buy-gallery-main">
          ${galleryHTML}
        </div>
        ${filteredMedia.length > 1 ? `
        <div class="quick-buy-gallery-thumbnails">
          ${thumbnailsHTML}
        </div>
        ` : ''}
      </div>

      <div class="quick-buy-info">
        <h2 class="quick-buy-title">${escapeHtml(product.title)}</h2>
        <div class="quick-buy-price">
          ${priceHTML}
        </div>

        <form class="quick-buy-form" action="${window.routes.cartAddUrl}" method="post" enctype="multipart/form-data">
          <input type="hidden" name="id" value="${selectedVariantId}" id="quick-buy-variant-id">
          <input type="hidden" name="quantity" value="1">

          <div class="quick-buy-variants">
            ${variantOptionsHTML}
          </div>

          <button type="submit"
                  class="quick-buy-submit Button Button--primary Button--full"
                  ${selectedVariant && selectedVariant.available ? '' : 'disabled'}>
            ${selectedVariant && selectedVariant.available ?
              escapeHtml(product.template_suffix === 'pre-order' ? _strings.preOrder : _strings.addToCart) :
              escapeHtml(_strings.soldOut)}
          </button>
        </form>
      </div>
    `;

    modalContent.innerHTML = html;
  }

  function initializeModal(product) {
    setTimeout(() => {
      const galleryMain = modalContent.querySelector('.quick-buy-gallery-main');
      if (!galleryMain) return;

      const slides = galleryMain.querySelectorAll('.quick-buy-gallery-slide');

      if (slides.length > 1 && typeof Flickity !== 'undefined') {
        if (currentFlickityInstance) {
          try {
            currentFlickityInstance.destroy();
          } catch(e) {}
        }

        const firstImage = slides[0]?.querySelector('img');
        const initFlickity = () => {
          currentFlickityInstance = new Flickity(galleryMain, {
            prevNextButtons: true,
            pageDots: true,
            adaptiveHeight: true,
            wrapAround: false,
            cellAlign: 'left',
            initialIndex: 0,
            imagesLoaded: true,
            lazyLoad: false,
            setGallerySize: true
          });

          const setViewportHeight = () => {
            if (currentFlickityInstance) {
              const viewport = galleryMain.querySelector('.flickity-viewport');
              const firstSlide = galleryMain.querySelector('.quick-buy-gallery-slide');
              if (viewport && firstSlide) {
                const img = firstSlide.querySelector('img');
                if (img) {
                  if (img.complete && img.naturalHeight > 0) {
                    viewport.style.height = img.offsetHeight + 'px';
                    currentFlickityInstance.resize();
                  } else {
                    img.onload = () => {
                      if (viewport && currentFlickityInstance) {
                        viewport.style.height = img.offsetHeight + 'px';
                        currentFlickityInstance.resize();
                      }
                    };
                  }
                }
              }
              currentFlickityInstance.resize();
            }
          };

          setTimeout(setViewportHeight, 100);
          setTimeout(setViewportHeight, 300);
          setTimeout(setViewportHeight, 500);
        };

        if (firstImage && !firstImage.complete) {
          firstImage.onload = () => {
            initFlickity();
          };
          setTimeout(initFlickity, 500);
        } else {
          initFlickity();
        }

        const thumbnailsContainer = modalContent.querySelector('.quick-buy-gallery-thumbnails');
        if (thumbnailsContainer) {
          thumbnailsContainer.addEventListener('click', (e) => {
            const thumb = e.target.closest('.quick-buy-gallery-thumb');
            if (thumb && currentFlickityInstance) {
              const index = parseInt(thumb.dataset.index);
              if (!isNaN(index)) {
                currentFlickityInstance.select(index);
              }
            }
          });
        }

        currentFlickityInstance.on('select', (index) => {
          const thumbs = modalContent.querySelectorAll('.quick-buy-gallery-thumb');
          thumbs.forEach((thumb, i) => {
            thumb.classList.toggle('is-selected', i === index);
          });
        });

        currentFlickityInstance.on('settle', () => {
          const selectedIndex = currentFlickityInstance.selectedIndex;
          const selectedSlide = galleryMain.querySelectorAll('.quick-buy-gallery-slide')[selectedIndex];
          if (selectedSlide) {
            const img = selectedSlide.querySelector('img');
            const viewport = galleryMain.querySelector('.flickity-viewport');
            if (img && viewport) {
              if (img.complete) {
                viewport.style.height = img.offsetHeight + 'px';
              } else {
                img.onload = () => {
                  if (viewport && currentFlickityInstance) {
                    viewport.style.height = img.offsetHeight + 'px';
                    currentFlickityInstance.resize();
                  }
                };
              }
            }
          }
        });

        currentFlickityInstance.on('change', (index) => {
          const slides = galleryMain.querySelectorAll('.quick-buy-gallery-slide');
          if (slides[index]) {
            const img = slides[index].querySelector('img');
            const viewport = galleryMain.querySelector('.flickity-viewport');
            if (img && viewport) {
              if (img.complete) {
                viewport.style.height = img.offsetHeight + 'px';
                if (currentFlickityInstance) {
                  currentFlickityInstance.resize();
                }
              } else {
                img.onload = () => {
                  if (viewport && currentFlickityInstance) {
                    viewport.style.height = img.offsetHeight + 'px';
                    currentFlickityInstance.resize();
                  }
                };
              }
            }
          }
        });
      }
    }, 100);

    // variant option changes
    const variantInputs = modalContent.querySelectorAll('.quick-buy-option-input, .quick-buy-option-button');
    variantInputs.forEach(input => {
      if (input.type === 'radio') {
        input.addEventListener('change', function() {
          const optionPosition = this.dataset.optionPosition;
          const optionGroup = modalContent.querySelectorAll(`input[type="radio"][data-option-position="${optionPosition}"]`);

          optionGroup.forEach(radioInput => {
            const radioLabel = modalContent.querySelector(`label[for="${radioInput.id}"]`);
            if (radioLabel && radioLabel.classList.contains('quick-buy-color-swatch')) {
              if (radioInput.checked) {
                radioLabel.classList.add('is-selected');
              } else {
                radioLabel.classList.remove('is-selected');
              }
            }
          });

          handleVariantChange();
        });

        const label = modalContent.querySelector(`label[for="${input.id}"]`);
        if (label && label.classList.contains('quick-buy-color-swatch')) {
          label.addEventListener('click', function(e) {
            setTimeout(() => {
              if (input.checked) {
                input.dispatchEvent(new Event('change'));
              }
            }, 10);
          });
        }
      } else {
        input.addEventListener('click', function(e) {
          e.preventDefault();
          const optionPosition = this.dataset.optionPosition;
          const optionGroup = modalContent.querySelectorAll(`[data-option-position="${optionPosition}"]`);
          optionGroup.forEach(btn => {
            if (btn.classList.contains('quick-buy-option-button')) {
              btn.classList.remove('is-selected');
            }
            if (btn.classList.contains('quick-buy-option-input')) {
              btn.checked = false;
            }
          });

          this.classList.add('is-selected');
          const hiddenInput = modalContent.querySelector(`input[name="quick-buy-option-${parseInt(optionPosition) - 1}"][value="${this.dataset.value}"]`);
          if (hiddenInput) {
            hiddenInput.checked = true;
          }

          handleVariantChange();
        });
      }
    });

    const form = modalContent.querySelector('.quick-buy-form');
    if (form) {
      form.addEventListener('submit', handleFormSubmit);
    }

    updateColorSwatchSelectionState();

    const selectedOptions = {};
    const optionInputs = modalContent.querySelectorAll('.quick-buy-option-input:checked, .quick-buy-option-button.is-selected');
    optionInputs.forEach(input => {
      const position = input.dataset.optionPosition;
      const value = input.value || input.dataset.value;
      selectedOptions[position] = value;
    });

    const initialVariant = product.variants.find(v => {
      let matches = true;
      for (let i = 1; i <= 3; i++) {
        const optionKey = 'option' + i;
        if (selectedOptions[i] && v[optionKey] !== selectedOptions[i]) {
          matches = false;
          break;
        }
      }
      return matches;
    }) || product.variants.find(v => v.available) || product.variants[0];

    if (initialVariant) {
      setTimeout(() => {
        updateOptionAvailability(initialVariant);
      }, 100);
    }
  }

  function handleVariantChange() {
    if (!currentProductData || !currentProductVariants) return;

    const selectedOptions = {};
    const optionInputs = modalContent.querySelectorAll('.quick-buy-option-input:checked, .quick-buy-option-button.is-selected');
    optionInputs.forEach(input => {
      const position = input.dataset.optionPosition;
      const value = input.value || input.dataset.value;
      selectedOptions[position] = value;
    });

    let matchingVariant = currentProductVariants.find(variant => {
      let matches = true;
      for (let i = 1; i <= 3; i++) {
        const optionKey = 'option' + i;
        if (selectedOptions[i] && variant[optionKey] !== selectedOptions[i]) {
          matches = false;
          break;
        }
      }
      return matches;
    });

    if (!matchingVariant) {
      matchingVariant = findPartialVariantMatch(selectedOptions);

      const colorOptionIndex = currentProductData.options.findIndex(opt =>
        colorLabel.includes(opt.name.toLowerCase())
      );

      if (colorOptionIndex !== -1) {
        const colorPosition = colorOptionIndex + 1;
        const selectedColor = selectedOptions[colorPosition];

        if (selectedColor && !matchingVariant) {

          const sizeOptionIndex = currentProductData.options.findIndex(opt =>
            sizeLabel.includes(opt.name.toLowerCase())
          );

          if (sizeOptionIndex !== -1) {
            const sizePosition = sizeOptionIndex + 1;

            const availableSizeVariant = currentProductVariants.find(variant => {
              const optionKey = 'option' + colorPosition;
              return variant[optionKey] === selectedColor && variant.available;
            });

            if (availableSizeVariant) {
              const availableSize = availableSizeVariant['option' + sizePosition];

              const sizeInputs = modalContent.querySelectorAll(`input[type="radio"][data-option-position="${sizePosition}"], .quick-buy-option-button[data-option-position="${sizePosition}"]`);
              sizeInputs.forEach(input => {
                const value = input.value || input.dataset.value;
                if (value === availableSize) {
                  if (input.type === 'radio') {
                    input.checked = true;
                  } else {
                    input.classList.add('is-selected');
                  }
                  selectedOptions[sizePosition] = availableSize;
                } else {
                  if (input.type === 'radio') {
                    input.checked = false;
                  } else {
                    input.classList.remove('is-selected');
                  }
                }
              });

              matchingVariant = currentProductVariants.find(variant => {
                let matches = true;
                for (let i = 1; i <= 3; i++) {
                  const optionKey = 'option' + i;
                  if (selectedOptions[i] && variant[optionKey] !== selectedOptions[i]) {
                    matches = false;
                    break;
                  }
                }
                return matches;
              });
            }
          }
        }
      }
    }

    if (matchingVariant) {
      updateVariantDisplay(matchingVariant);
      updateVariantImages(matchingVariant);
      updateColorSwatchSelectionState();
    } else {
      const selectedColor = getSelectedColorFromOptions(selectedOptions);
      if (selectedColor) {
        updateVariantImagesByColor(selectedColor);

        const colorVariant = currentProductVariants.find(v => {
          const colorOptionIndex = currentProductData.options.findIndex(opt =>
            colorLabel.includes(opt.name.toLowerCase())
          );
          if (colorOptionIndex !== -1) {
            const colorPosition = colorOptionIndex + 1;
            const optionKey = 'option' + colorPosition;
            return v[optionKey] === selectedColor;
          }
          return false;
        });

        if (colorVariant) {
          const priceContainer = modalContent.querySelector('.quick-buy-price');
          if (priceContainer) {
            const currencyFormat = window.theme && window.theme.currencyCodeEnabled ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat;
            const price = colorVariant.price;
            const compareAtPrice = colorVariant.compare_at_price > price ? colorVariant.compare_at_price : null;

            let priceHTML = '';
            if (compareAtPrice) {
              priceHTML = `
                <span class="quick-buy-price-current">${formatMoney(price, currencyFormat)}</span>
                <span class="quick-buy-price-compare">${formatMoney(compareAtPrice, currencyFormat)}</span>
              `;
            } else if (currentProductDiscountedPrice && (currentProductDiscountedPrice.discountedPriceCents != null && currentProductDiscountedPrice.discountedPriceCents !== '') && (currentProductDiscountedPrice.originalPriceCents != null && currentProductDiscountedPrice.originalPriceCents !== '')) {
              const discountedCents = parsePriceCents(currentProductDiscountedPrice.discountedPriceCents);
              const originalCents = parsePriceCents(currentProductDiscountedPrice.originalPriceCents);
              priceHTML = `
                <span class="quick-buy-price-current">${formatMoney(discountedCents, currencyFormat)}</span>
                <span class="quick-buy-price-compare">${formatMoney(originalCents, currencyFormat)}</span>
              `;
            } else {
              priceHTML = `<span class="quick-buy-price-current">${formatMoney(price, currencyFormat)}</span>`;
            }
            priceContainer.innerHTML = priceHTML;
          }

          const submitButton = modalContent.querySelector('.quick-buy-submit');
          if (submitButton) {
            submitButton.disabled = true;
            submitButton.textContent = _strings.unavailable;
          }
        }
      }

      updateColorSwatchSelectionState();
    }
  }

  function getSelectedColorFromOptions(selectedOptions) {
    if (!currentProductData || !currentProductData.options) return null;

    const colorOptionIndex = currentProductData.options.findIndex(opt =>
      colorLabel.includes(opt.name.toLowerCase())
    );

    if (colorOptionIndex !== -1) {
      const colorPosition = colorOptionIndex + 1;
      return selectedOptions[colorPosition] || null;
    }

    return null;
  }

  function updateVariantImagesByColor(selectedColor) {
    if (!currentProductData || !selectedColor) return;

    let productMedia = [];
    if (currentProductData.media && currentProductData.media.length > 0) {
      productMedia = currentProductData.media.filter(m => m.media_type === 'image');
    } else if (currentProductData.images && currentProductData.images.length > 0) {
      productMedia = currentProductData.images.map(img => ({
        src: img,
        alt: currentProductData.title,
        id: img
      }));
    }

    let filteredMedia = productMedia.filter(m => {
      const alt = (m.alt || '').toLowerCase().trim();
      const colorLower = selectedColor.toLowerCase().trim();
      const titleLower = currentProductData.title.toLowerCase().trim();

      return alt === colorLower || alt === titleLower || !alt || alt === '';
    });

    if (filteredMedia.length === 0) {
      filteredMedia = productMedia;
    }

    updateGalleryWithMedia(filteredMedia);
  }

  function updateGalleryWithMedia(mediaToShow) {
    const galleryMain = modalContent.querySelector('.quick-buy-gallery-main');
    const thumbnails = modalContent.querySelector('.quick-buy-gallery-thumbnails');

    if (!galleryMain) return;

    let galleryHTML = '';
    let thumbnailsHTML = '';

    mediaToShow.forEach((media, index) => {
      let imageUrl = media.src || media;

      if (typeof imageUrl === 'string') {
        imageUrl = imageUrl.replace(/_\d+x\d+/g, '');
        imageUrl = imageUrl.replace(/\?.*$/, '');
      }

      const imageUrl400 = imageUrl + (imageUrl.includes('?') ? '&' : '?') + 'width=400';
      const imageUrl800 = imageUrl + (imageUrl.includes('?') ? '&' : '?') + 'width=800';

      galleryHTML += `
        <div class="quick-buy-gallery-slide" data-media-id="${media.id || index}">
          <img src="${imageUrl800}" alt="${escapeHtml(media.alt || currentProductData.title)}" loading="${index === 0 ? 'eager' : 'lazy'}">
        </div>
      `;

      if (mediaToShow.length > 1) {
        thumbnailsHTML += `
          <button type="button" class="quick-buy-gallery-thumb ${index === 0 ? 'is-selected' : ''}" data-index="${index}">
            <img src="${imageUrl400}" alt="${escapeHtml(media.alt || currentProductData.title)}">
          </button>
        `;
      }
    });

    if (currentFlickityInstance) {
      try {
        currentFlickityInstance.off('select');
        currentFlickityInstance.off('settle');
        currentFlickityInstance.off('change');
        currentFlickityInstance.destroy();
      } catch(e) {
        // console.error('Error destroying Flickity:', e);
      }
      currentFlickityInstance = null;
    }

    const existingViewport = galleryMain.querySelector('.flickity-viewport');
    if (existingViewport) {
      const slider = existingViewport.querySelector('.flickity-slider');
      if (slider) {
        const existingSlides = Array.from(slider.children);
        existingSlides.forEach(slide => {
          galleryMain.appendChild(slide);
        });
      }
      existingViewport.remove();
    }

    galleryMain.classList.remove('flickity-enabled', 'flickity-rtl', 'flickity-enabled-is-fade');
    const flickityButtons = galleryMain.querySelectorAll('.flickity-prev-next-button, .flickity-page-dots');
    flickityButtons.forEach(btn => btn.remove());
    galleryMain.removeAttribute('style');

    galleryMain.innerHTML = galleryHTML;
    if (thumbnails) {
      thumbnails.innerHTML = thumbnailsHTML;
    }

    setTimeout(() => {
      const slides = galleryMain.querySelectorAll('.quick-buy-gallery-slide');

      if (mediaToShow.length > 1 && typeof Flickity !== 'undefined' && slides.length > 1) {
        const firstImage = slides[0]?.querySelector('img');
        const initFlickityAfterUpdate = () => {
          if (typeof Flickity === 'undefined') {
            // console.error('Flickity is not available');
            return;
          }

          galleryMain.classList.remove('flickity-enabled', 'flickity-rtl', 'flickity-enabled-is-fade');

          currentFlickityInstance = new Flickity(galleryMain, {
            prevNextButtons: true,
            pageDots: true,
            adaptiveHeight: true,
            wrapAround: false,
            cellAlign: 'left',
            initialIndex: 0,
            imagesLoaded: true,
            lazyLoad: false,
            setGallerySize: true
          });

          const thumbnailsContainer = modalContent.querySelector('.quick-buy-gallery-thumbnails');
          if (thumbnailsContainer) {
            const newContainer = thumbnailsContainer.cloneNode(true);
            thumbnailsContainer.parentNode.replaceChild(newContainer, thumbnailsContainer);

            newContainer.addEventListener('click', (e) => {
              const thumb = e.target.closest('.quick-buy-gallery-thumb');
              if (thumb && currentFlickityInstance) {
                const index = parseInt(thumb.dataset.index);
                if (!isNaN(index) && index >= 0) {
                  currentFlickityInstance.select(index);
                }
              }
            });
          }

          currentFlickityInstance.on('select', (index) => {
            const thumbs = modalContent.querySelectorAll('.quick-buy-gallery-thumb');
            thumbs.forEach((thumb, i) => {
              thumb.classList.toggle('is-selected', i === index);
            });
          });

          currentFlickityInstance.on('settle', () => {
            if (!currentFlickityInstance) return;
            const selectedIndex = currentFlickityInstance.selectedIndex;
            const selectedSlide = galleryMain.querySelectorAll('.quick-buy-gallery-slide')[selectedIndex];
            if (selectedSlide) {
              const img = selectedSlide.querySelector('img');
              const viewport = galleryMain.querySelector('.flickity-viewport');
              if (img && viewport) {
                if (img.complete) {
                  viewport.style.height = img.offsetHeight + 'px';
                  currentFlickityInstance.resize();
                } else {
                  img.onload = () => {
                    if (viewport && currentFlickityInstance) {
                      viewport.style.height = img.offsetHeight + 'px';
                      currentFlickityInstance.resize();
                    }
                  };
                }
              }
            }
          });

          currentFlickityInstance.on('change', (index) => {
            if (!currentFlickityInstance) return;
            const slides = galleryMain.querySelectorAll('.quick-buy-gallery-slide');
            if (slides[index]) {
              const img = slides[index].querySelector('img');
              const viewport = galleryMain.querySelector('.flickity-viewport');
              if (img && viewport) {
                if (img.complete) {
                  viewport.style.height = img.offsetHeight + 'px';
                  if (currentFlickityInstance) {
                    currentFlickityInstance.resize();
                  }
                } else {
                  img.onload = () => {
                    if (viewport && currentFlickityInstance) {
                      viewport.style.height = img.offsetHeight + 'px';
                      currentFlickityInstance.resize();
                    }
                  };
                }
              }
            }
          });

          const setViewportHeight = () => {
            if (currentFlickityInstance) {
              const viewport = galleryMain.querySelector('.flickity-viewport');
              const firstSlide = galleryMain.querySelector('.quick-buy-gallery-slide');
              if (viewport && firstSlide) {
                const img = firstSlide.querySelector('img');
                if (img) {
                  if (img.complete && img.naturalHeight > 0) {
                    viewport.style.height = img.offsetHeight + 'px';
                    currentFlickityInstance.resize();
                  } else {
                    img.onload = () => {
                      if (viewport && currentFlickityInstance) {
                        viewport.style.height = img.offsetHeight + 'px';
                        currentFlickityInstance.resize();
                      }
                    };
                  }
                }
              }
              currentFlickityInstance.resize();
            }
          };

          setTimeout(setViewportHeight, 100);
          setTimeout(setViewportHeight, 300);
          setTimeout(setViewportHeight, 500);
        };

        if (firstImage && !firstImage.complete) {
          firstImage.onload = () => {
            initFlickityAfterUpdate();
          };
          setTimeout(initFlickityAfterUpdate, 1000);
        } else {
          initFlickityAfterUpdate();
        }
      } else if (slides.length === 1) {
        const firstSlide = slides[0];
        if (firstSlide) {
          firstSlide.style.display = 'block';
        }
      }
    }, 150);
  }

  function updateVariantDisplay(variant) {
    const variantIdInput = modalContent.querySelector('#quick-buy-variant-id');
    if (variantIdInput) {
      variantIdInput.value = variant.id;
    }

    const priceContainer = modalContent.querySelector('.quick-buy-price');
    if (priceContainer) {
      const currencyFormat = window.theme && window.theme.currencyCodeEnabled ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat;
      const price = variant.price;
      const compareAtPrice = variant.compare_at_price > price ? variant.compare_at_price : null;

      let priceHTML = '';
      if (compareAtPrice) {
        priceHTML = `
          <span class="quick-buy-price-current">${formatMoney(price, currencyFormat)}</span>
          <span class="quick-buy-price-compare">${formatMoney(compareAtPrice, currencyFormat)}</span>
        `;
      } else if (currentProductDiscountedPrice && (currentProductDiscountedPrice.discountedPriceCents != null && currentProductDiscountedPrice.discountedPriceCents !== '') && (currentProductDiscountedPrice.originalPriceCents != null && currentProductDiscountedPrice.originalPriceCents !== '')) {
        const discountedCents = parsePriceCents(currentProductDiscountedPrice.discountedPriceCents);
        const originalCents = parsePriceCents(currentProductDiscountedPrice.originalPriceCents);
        priceHTML = `
          <span class="quick-buy-price-current">${formatMoney(discountedCents, currencyFormat)}</span>
          <span class="quick-buy-price-compare">${formatMoney(originalCents, currencyFormat)}</span>
        `;
      } else {
        priceHTML = `<span class="quick-buy-price-current">${formatMoney(price, currencyFormat)}</span>`;
      }
      priceContainer.innerHTML = priceHTML;
    }

    const submitButton = modalContent.querySelector('.quick-buy-submit');
    if (submitButton) {
      if (variant.available) {
        submitButton.disabled = false;
        submitButton.textContent = currentProductData.template_suffix === 'pre-order' ? _strings.preOrder : _strings.addToCart;
      } else {
        submitButton.disabled = true;
        submitButton.textContent = _strings.soldOut;
      }
    }

    updateOptionLabels(variant);

    updateOptionAvailability(variant);
  }

  function updateOptionLabels(variant) {
    if (!currentProductData || !variant || !modalContent) return;

    if (currentProductData.options && currentProductData.options.length > 0) {
      currentProductData.options.forEach((option, optionIndex) => {
        const optionPosition = optionIndex + 1;
        const optionKey = 'option' + optionPosition;
        const selectedValue = variant[optionKey] || '';
        const downcaseOption = option.name.toLowerCase();
        const isColor = colorLabel.includes(downcaseOption);

        const optionContainer = modalContent.querySelector(`.quick-buy-option[data-option-position="${optionPosition}"]`);
        if (optionContainer) {
          const label = optionContainer.querySelector('.quick-buy-option-label');
          if (label && isColor && selectedValue) {
            const cleanValue = selectedValue.split('(')[0].trim();
            label.textContent = option.name + ': ' + cleanValue;
          } else if (label && isColor && !selectedValue) {
            label.textContent = option.name + ':';
          }
        }
      });
    }
  }

  function updateVariantImages(variant) {
    if (!currentProductData || !variant) return;

    const selectedColor = getSelectedColor(currentProductData, variant);

    let productMedia = [];
    if (currentProductData.media && currentProductData.media.length > 0) {
      productMedia = currentProductData.media.filter(m => m.media_type === 'image');
    } else if (currentProductData.images && currentProductData.images.length > 0) {
      productMedia = currentProductData.images.map(img => ({
        src: img,
        alt: currentProductData.title,
        id: img
      }));
    }

    let filteredMedia = productMedia.filter(m => {
      const alt = (m.alt || '').toLowerCase().trim();
      const colorLower = selectedColor.toLowerCase().trim();
      const titleLower = currentProductData.title.toLowerCase().trim();

      return alt === colorLower || alt === titleLower || !alt || alt === '';
    });

    if (filteredMedia.length === 0) {
      filteredMedia = productMedia;
    }

    let mediaToShow = filteredMedia;
    if (variant && variant.featured_image) {
      const variantImageId = variant.featured_image.id || variant.featured_image;
      const variantImageIndex = filteredMedia.findIndex(m => {
        const mediaId = m.id || m;
        return mediaId === variantImageId || m.src === variant.featured_image.src;
      });
      if (variantImageIndex !== -1) {
        mediaToShow = [filteredMedia[variantImageIndex], ...filteredMedia.filter((_, i) => i !== variantImageIndex)];
      } else if (variant.featured_image.src) {
        mediaToShow = [{ src: variant.featured_image.src, alt: selectedColor, id: variantImageId }, ...filteredMedia];
      }
    }

    if (mediaToShow.length === 0) {
      if (currentProductData.media && currentProductData.media.length > 0) {
        mediaToShow = currentProductData.media.filter(m => m.media_type === 'image');
      } else if (currentProductData.images && currentProductData.images.length > 0) {
        mediaToShow = currentProductData.images.map(img => ({
          src: img,
          alt: currentProductData.title,
          id: img
        }));
      }
    }

    if (mediaToShow.length > 0) {
      updateGalleryWithMedia(mediaToShow);
    }
  }

  function updateOptionAvailability(selectedVariant) {
    if (!currentProductData || !currentProductVariants || !modalContent) return;

    const selectedOptions = {};
    const optionInputs = modalContent.querySelectorAll('.quick-buy-option-input:checked, .quick-buy-option-button.is-selected');
    optionInputs.forEach(input => {
      const position = input.dataset.optionPosition;
      const value = input.value || input.dataset.value;
      selectedOptions[position] = value;
    });

    currentProductData.options.forEach((option, optionIndex) => {
      const optionPosition = optionIndex + 1;
      const downcaseOption = option.name.toLowerCase();
      const isColor = colorLabel.includes(downcaseOption);
      const isSize = sizeLabel.includes(downcaseOption);

      const allButtons = modalContent.querySelectorAll(`.quick-buy-option-button[data-option-position="${optionPosition}"], input[type="radio"][data-option-position="${optionPosition}"]`);

      option.values.forEach((value, valueIndex) => {
        const testOptions = {...selectedOptions};
        testOptions[optionPosition] = value;

        const isAvailable = isVariantValueAvailable(currentProductVariants, optionPosition, value, selectedVariant, testOptions);

        let input = null;
        let button = null;
        let label = null;

        input = modalContent.querySelector(`#quick-buy-option-${optionIndex}-${valueIndex}`);
        if (input) {
          label = modalContent.querySelector(`label[for="quick-buy-option-${optionIndex}-${valueIndex}"]`);
        }

        if (isSize && allButtons.length > 0) {
          allButtons.forEach(btn => {
            if (btn.classList.contains('quick-buy-option-button')) {
              const btnValue = btn.dataset.value || btn.textContent.trim();
              const normalizedBtnValue = btnValue.toLowerCase().trim();
              const normalizedValue = value.toLowerCase().trim();
              if (btnValue === value || normalizedBtnValue === normalizedValue) {
                button = btn;
              }
            }
          });
        }

        const isColorSwatch = label && label.classList.contains('quick-buy-color-swatch');

        if (input) {
          if (!isColorSwatch) {
            input.disabled = !isAvailable;
          } else {
            input.dataset.isAvailable = isAvailable;
          }
        }
        if (button) {
          const matchingVariant = currentProductVariants.find(variant => {
            let matches = true;
            for (let i = 1; i <= 3; i++) {
              const optionKey = 'option' + i;
              if (testOptions[i] && variant[optionKey] !== testOptions[i]) {
                matches = false;
                break;
              }
            }
            return matches;
          });

          const finalIsAvailable = matchingVariant ? matchingVariant.available : false;
          button.classList.toggle('is-unavailable', !finalIsAvailable);
        }
        if (label) {
          label.classList.toggle('is-unavailable', !isAvailable);
        }
      });
    });

    const sizeOptionPositions = [];
    currentProductData.options.forEach((option, optionIndex) => {
      const downcaseOption = option.name.toLowerCase();
      if (sizeLabel.includes(downcaseOption)) {
        sizeOptionPositions.push(optionIndex + 1);
      }
    });

    sizeOptionPositions.forEach(sizePosition => {
      const sizeButtons = modalContent.querySelectorAll(`.quick-buy-option-button[data-option-position="${sizePosition}"]`);
      sizeButtons.forEach(btn => {
        const btnValue = btn.dataset.value || btn.textContent.trim();
        const matchingOption = currentProductData.options[sizePosition - 1];
        if (matchingOption) {
          const matchingValue = matchingOption.values.find(v => {
            const normalizedV = v.toLowerCase().trim();
            const normalizedBtn = btnValue.toLowerCase().trim();
            return v === btnValue || normalizedV === normalizedBtn;
          });

          if (matchingValue) {
            const testOptions = {...selectedOptions};
            testOptions[sizePosition] = matchingValue;

            const matchingVariant = currentProductVariants.find(variant => {
              let matches = true;
              for (let i = 1; i <= 3; i++) {
                const optionKey = 'option' + i;
                if (testOptions[i] && variant[optionKey] !== testOptions[i]) {
                  matches = false;
                  break;
                }
              }
              return matches;
            });

            const isAvailable = matchingVariant ? matchingVariant.available : false;
            btn.classList.toggle('is-unavailable', !isAvailable);
          }
        }
      });
    });
  }

  function handleFormSubmit(e) {
    e.preventDefault();

    const form = e.target;
    const formData = new FormData(form);
    const submitButton = form.querySelector('.quick-buy-submit');

    if (submitButton.disabled) return;

    submitButton.disabled = true;
    const originalText = submitButton.textContent;
    submitButton.textContent = _strings.adding;

    fetch(window.routes.cartAddUrl + '.js', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(item => {
      closeModal();

      const quantity = parseInt(formData.get('quantity') || '1', 10);

      document.dispatchEvent(new CustomEvent('product:added', {
        detail: {
          quantity: quantity,
          variant: item.variant_id,
          product: item.product_id
        }
      }));
    })
    .catch(error => {
      // console.error('Error adding to cart:', error);
      submitButton.disabled = false;
      submitButton.textContent = originalText;
      alert(_strings.addError);
    });
  }

  function updateColorSwatchSelectionState() {
    if (!currentProductData || !currentProductData.options || !modalContent) return;

    currentProductData.options.forEach((option, optionIndex) => {
      const optionPosition = optionIndex + 1;
      const downcaseOption = option.name.toLowerCase();
      const isColor = colorLabel.includes(downcaseOption);

      if (isColor) {
        const colorInputs = modalContent.querySelectorAll(`input[type="radio"][data-option-position="${optionPosition}"]`);

        colorInputs.forEach(input => {
          const label = modalContent.querySelector(`label[for="${input.id}"]`);
          if (label && label.classList.contains('quick-buy-color-swatch')) {
            if (input.checked) {
              label.classList.add('is-selected');
            } else {
              label.classList.remove('is-selected');
            }
          }
        });
      }
    });
  }

  function findPartialVariantMatch(selectedOptions) {
    if (!currentProductVariants) return null;

    const colorPosition = Object.keys(selectedOptions).find(pos => {
      const option = currentProductData.options[parseInt(pos) - 1];
      return option && colorLabel.includes(option.name.toLowerCase());
    });

    if (colorPosition) {
      const colorValue = selectedOptions[colorPosition];
      return currentProductVariants.find(v => {
        const optionKey = 'option' + colorPosition;
        return v[optionKey] === colorValue && v.available;
      });
    }

    return null;
  }

  function getSelectedColor(product, variant) {
    if (!variant || !product.options) return product.title || '';

    const colorOptionIndex = product.options.findIndex(opt =>
      colorLabel.includes(opt.name.toLowerCase())
    );

    if (colorOptionIndex !== -1) {
      const optionKey = 'option' + (colorOptionIndex + 1);
      return variant[optionKey] || product.title || '';
    }

    return product.title || '';
  }

  function getVariantOptionValue(variant, optionPosition) {
    const optionKey = 'option' + optionPosition;
    return variant[optionKey] || null;
  }

  function isVariantValueAvailable(variants, optionPosition, value, currentVariant, testOptions) {
    if (!variants || !variants.length) return false;

    const options = testOptions || {};
    options[optionPosition] = value;

    return variants.some(variant => {
      let matches = true;
      for (let i = 1; i <= 3; i++) {
        const optionKey = 'option' + i;
        if (options[i] && variant[optionKey] !== options[i]) {
          matches = false;
          break;
        }
      }
      return matches && variant.available;
    });
  }

  function getColorSwatchStyle(value) {
    const colorValueDowncase = value.toLowerCase();
    let colorSwatchStyle = 'background-color: ' + colorValueDowncase;

    if (colorSwatchConfig && colorSwatchConfig.length > 0) {
      for (let i = 0; i < colorSwatchConfig.length; i++) {
        const configItem = colorSwatchConfig[i];
        if (!configItem || configItem.trim() === '') continue;

        const parts = configItem.split(':');
        if (parts.length !== 2) continue;

        const configName = parts[0].toLowerCase().trim();
        const configValue = parts[1].trim();

        if (colorValueDowncase === configName) {
          if (configValue.indexOf('#') !== -1) {
            colorSwatchStyle = 'background-color: ' + configValue;
          } else {
            let imageFilename = configValue;
            if (!imageFilename.match(/\.(png|jpg|jpeg|gif|webp)$/i)) {
              imageFilename = imageFilename + '.png';
            }
            const imageUrl = _fileUrlBase + encodeURIComponent(imageFilename) + '?width=72';
            colorSwatchStyle = 'background-image: url(' + imageUrl + ')';
          }
          break;
        }
      }
    }

    return colorSwatchStyle;
  }

  function parsePriceCents(str) {
    if (str == null || str === '') return 0;
    const num = parseFloat(String(str).replace(/,/g, ''));
    if (isNaN(num)) return 0;
    if (num < 1000 && String(str).indexOf('.') !== -1) return Math.round(num * 100);
    if (num < 1000 && num === Math.floor(num) && !String(str).includes('.')) return num;
    return Math.round(num);
  }

  function formatMoney(cents, format) {
    if (typeof cents !== 'number') {
      cents = parseFloat(cents) || 0;
    }

    const value = cents / 100;
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = (format || '${{amount}}');

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      const parts = number.split('.');
      const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    const placeholder = formatString.match(placeholderRegex)[1];
    let formattedAmount;
    switch (placeholder) {
      case 'amount':
        formattedAmount = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        formattedAmount = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        formattedAmount = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        formattedAmount = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        formattedAmount = value.toFixed(2);
    }
    return formatString.replace(placeholderRegex, formattedAmount);
  }

  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  document.addEventListener('click', function(e) {
    const quickBuyButton = e.target.closest('[data-quick-add-btn]');
    if (quickBuyButton) {
      const productHandle = quickBuyButton.dataset.productHandle;
      if (productHandle) {
        if (quickBuyButton.type === 'submit') {
          e.preventDefault();
          e.stopPropagation();
        }
        const discountedPriceCents = quickBuyButton.dataset.productDiscountedPriceCents;
        const originalPriceCents = quickBuyButton.dataset.productOriginalPriceCents;
        
        // Code by 643 - comment old
        // openModal(productHandle, (discountedPriceCents && originalPriceCents) ? { discountedPriceCents, originalPriceCents } : null);
        const selectedVariantId = quickBuyButton.dataset.selectedVariantId;
        openModal(productHandle, (discountedPriceCents && originalPriceCents) ? { discountedPriceCents, originalPriceCents } : null, selectedVariantId);
        // End of 643
      }
    }
  });

  if (closeButton) {
    closeButton.addEventListener('click', closeModal);
  }

  if (modal) {
    modal.addEventListener('click', function(e) {
      if (e.target === modal) {
        closeModal();
      }
    });
  }

  // Close on ESC key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal && modal.classList.contains('is-open')) {
      closeModal();
    }
  });
})();
